import { formatDateToNumericUTC } from "~/shared/components/trax-grid/date-cell/date-cell.tsx";
import type { Load } from "~/shared/schemas/loads-schema.ts";
import type { BoardColumn } from "~/shared/types/quote-board-types";
import { dateMatchesSearch } from "~/shared/utils/date-search.ts";

const DATE_DISPLAY_FIELDS = new Set(["loadDateValue", "deliveryDateValue"]);

/**
 * Search All matcher: text values use a substring match; date columns also
 * accept date variations such as `9/1`, `9/1/26` or `09/01/2026`.
 */
export const loadMatchesSearchAll = (
	load: Load,
	columns: BoardColumn[],
	term: string,
): boolean => {
	const lowerTerm = term.toLowerCase();

	return columns.some((column) => {
		if (typeof column.field !== "string" || column.field === "") {
			return false;
		}

		const rawValue = load[column.field as keyof Load];
		if (rawValue == null || rawValue === "") return false;

		// Date columns use exact month/day(/year) matching only; a substring
		// match on the formatted text would let `9/1` hit 09/10 - 09/19.
		if (DATE_DISPLAY_FIELDS.has(column.field)) {
			return dateMatchesSearch(
				rawValue as Date | string | null | undefined,
				term,
				"utc",
			);
		}

		return String(rawValue).toLowerCase().includes(lowerTerm);
	});
};

export const getLoadBoardSearchValues = (
	load: Load,
	columns: BoardColumn[],
): string[] => {
	return columns.flatMap((column) => {
		if (typeof column.field !== "string" || column.field === "") {
			return [];
		}

		const rawValue = load[column.field as keyof Load];
		if (rawValue == null || rawValue === "") {
			return [];
		}

		if (DATE_DISPLAY_FIELDS.has(column.field)) {
			return [
				formatDateToNumericUTC(rawValue as Date | string | null | undefined),
			];
		}

		return [String(rawValue)];
	});
};
